<script setup>
import {
	ref,
	onMounted,
} from 'vue'
import { Log } from '@/modules/util/log'
import { mdiMessage } from '@mdi/js'

const logList = ref(null)
const items = ref([])

const refresh = async () => {
	items.value = (await Log.fetchAll()).map(item => ({ 
		...item, 
		type: item.type === Log.DEFAULT ? undefined : item.type,
		icon: item.type === Log.DEFAULT ? mdiMessage : undefined,
	})) || []
}

const calcListHeight = () => {
	if (logList.value) {
		logList.value.style.height = `${window.innerHeight - logList.value.getBoundingClientRect().top}px`
	}
}

onMounted(() => {
	refresh()
	Log.subscribe(refresh)

	calcListHeight()
	window.addEventListener('resize', calcListHeight)
})
</script>

<template>
<div
	ref="logList"
	style="display: flex; flex-direction: column;"
>
	<v-virtual-scroll
		:items="items"
		item-height="60"
	>
		<template #default="{ item }">
			<v-list-item lines="two">
				<v-alert 
					:type="item.type"
					:icon="item.icon"
				>
					{{ new Date(item.timestamp).toLocaleString() }} - {{ item.message }}
				</v-alert>
			</v-list-item>
		</template>
	</v-virtual-scroll>
</div>
</template>



<style lang="scss" scoped>

</style>